import styled from 'styled-components'

export const ContentLayoutStyle = styled.div`
  width: 100%;
  max-width: 1280px;
`
